/** 
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
    
    $('#easy-filter-wrap').easyFilter();
    $('#easy-filter-radio').easyFilter({
        firstFilter: 'item12'
    });

  /* home page gallery sec */
  
  $('.cust_gallery_slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: '40px',
    arrows: true,
    prevArrow: '<div class="custm_slick-up text-center"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></div>',
    nextArrow: '<div class="custm_slick-down text-center"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          loop:true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
  
/* end home page gallery sec */

 
  
if ($("body").hasClass("GiftCardPrd")) {
  console.log("gift card page");
  $(".variantoptions.custvar_1").prepend('<option value="Choose a option" selected="selected" disabled="disabled">Gift Card Value (USD $)</option>');
  $(".ProductMeta__Price").text("$10-$150");
 
  
  $('.variantoptions').on('change', function() {  
      var collVariant = $(this).val();
      console.log(collVariant+" is selected");  
    
        $(".Popover__ValueList").children(".Popover__Value").each(function(index){
          console.log(index);
          var optionVal =  $(this).attr("data-value");
          console.log("optionVal "+ optionVal);
          var thisSel= $(this);
          if(collVariant == optionVal ){
            console.log("matched"); 
            thisSel[0].click();
          }

        });
       
    });
 
  
} else{
  console.log("not gift card page");
  //$(".variantoptions.custvar_1").prepend('<option value="Choose a option" selected="selected" >Choose Your Base</option>');
 // $(".variantoptions.custvar_2").prepend('<option value="Choose a option" selected="selected" >Choose Option</option>');
  var CoountDrop="0", CountPOnCase="0", CountPOnBox="0";
  
  /* put a name   word counter */ 
  $('.cust_input').keyup(newupdateCount);
  $('.cust_input').keydown(newupdateCount);
  
  $('.cust_input3').keyup(newupdateCount3);
  $('.cust_input3').keydown(newupdateCount3);

  $('.cust_input2').keyup(newupdateCount2);
  $('.cust_input2').keydown(newupdateCount2);
  	
  function newupdateCount() {
    
    var lipcustwords = $(this).val().length;
    
    var liptextPrintOnCase = $(this).val();
    $('p#printOnCase_livePreview span').html(liptextPrintOnCase);
    $('p#printOnCase_livePreviewMob span').html(liptextPrintOnCase);
    
    var lipPOC_width= $('#printOnCase_livePreview').width();
    console.log("POC_width --: "+lipPOC_width);


    if(lipcustwords <= '20'){

      if(lipPOC_width <= '320' ){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
      } 
      if((lipPOC_width >= '321') && (lipPOC_width <= '380')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-1');
      }
      if((lipPOC_width >= '381') && (lipPOC_width <= '440')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-2');
      }
      if((lipPOC_width >= '441') && (lipPOC_width <= '500')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-3');
      }
      if((lipPOC_width >= '501') && (lipPOC_width <= '560')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-4');
      }
      if((lipPOC_width >= '561') && (lipPOC_width <= '620')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-5');
      }
      if((lipPOC_width >= '621') && (lipPOC_width <= '680')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-6');
      } 
      if((lipPOC_width >= '681') && (lipPOC_width <= '740')){
        $('#printOnCase_livePreview').removeClass('fixfont-1');
        $('#printOnCase_livePreview').removeClass('fixfont-2');
        $('#printOnCase_livePreview').removeClass('fixfont-3');
        $('#printOnCase_livePreview').removeClass('fixfont-4');
        $('#printOnCase_livePreview').removeClass('fixfont-5');
        $('#printOnCase_livePreview').removeClass('fixfont-6');
        $('#printOnCase_livePreview').addClass('fixfont-6');
      } 
    }

    
    $('.cust_counter').text(lipcustwords +"/" +20);
    
    if(lipcustwords > '0'){
      console.log('added print on case');
      CountPOnCase = '1';
    } else{
      CountPOnCase = '0';
    }
    if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      //$('.shopify-payment-button__button').prop('disabled', true);
      //$('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      //$('.shopify-payment-button__button').prop('disabled', true);
      //$('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    //console.log("CoountDrop: "+CoountDrop+", CountPOnCase: "+CountPOnCase+", CountPOnBox: "+CountPOnBox);

    /* add/remove  class in div when chracter count 14*/

    console.log("LIP WORD "+lipcustwords)
    if(lipcustwords > 14){
      $(".bt-text-edit-case-inn-text").addClass("cust-case-text-content");
    }else if(lipcustwords > 20 ){
      $(".bt-text-edit-case-inn-text").addClass("cust-case-text-content-2");
    }
    else{
      $(".bt-text-edit-case-inn-text").removeClass("cust-case-text-content");
    }
    /* end add/remove class in div when chracter count 14*/
  }
  function newupdateCount3() {
    
    var custwords3 = $(this).val().length;
    
    var textPrintOnCase = $(this).val();
    $('p#printOnCase_livePreviewDesk span').html(textPrintOnCase);
    $('p#printOnCase_livePreviewnewMob span').html(textPrintOnCase);
    
    var POC_width3= $('#printOnCase_livePreviewDesk').width();
    console.log("POC_width: "+POC_width3);


    if(custwords3 <= '15'){

      if(POC_width3 <= '320' ){
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-1');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-2');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-3');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-4');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-5');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-6');
      } 
      if((POC_width3 >= '321') && (POC_width3 <= '380')){
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-1');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-2');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-3');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-4');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-5');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-6');
        $('#printOnCase_livePreviewDesk').addClass('fixfont-1');
      }
      if((POC_width3 >= '381') && (POC_width3 <= '440')){
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-1');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-2');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-3');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-4');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-5');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-6');
        $('#printOnCase_livePreviewDesk').addClass('fixfont-2');
      }
      if((POC_width3 >= '441') && (POC_width3 <= '500')){
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-1');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-2');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-3');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-4');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-5');
        $('#printOnCase_livePreviewDesk').removeClass('fixfont-6');
        $('#printOnCase_livePreviewDesk').addClass('fixfont-3');
      }

    }

    
    $('.new_cust_counter').text(custwords3 +"/" +15);
    if(custwords3 > '0'){
      console.log('added print on case');
      CountPOnCase = '1';
    } else{
      CountPOnCase = '0';
    }
    if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    //console.log("CoountDrop: "+CoountDrop+", CountPOnCase: "+CountPOnCase+", CountPOnBox: "+CountPOnBox);

    /* add/remove  class in div when chracter count 14*/
    if(custwords3 > '14'){
      $(".bt-text-edit-case-inn-text").addClass("cust-case-text-content");
    }
    else{
      $(".bt-text-edit-case-inn-text").removeClass("cust-case-text-content");
    }
    /* end add/remove class in div when chracter count 14*/
  }
  
  var country1 = 'IT';

fetch('https://ipapi.co/country/')
  .then(function(response) {
    return response.text();
  })
  .then(function(data) {
    console.log(data)
    if (data == country1) {
      window.location.href='https://bookingbeautytailornyc.com/not-available'
    } 
  });
  
  
  /** Start script three lines combined for textarea **/
  var dataline_1='', dataline_2='', dataline_3='', countline_1='0', countline_2='0', countline_3='0', final_data='', total_word_count='', final_break_hide=''; 
  $(document).on('input','.pobline_1', function(e){
    dataline_1= $(this).val();
    if(dataline_1 != ""){
      console.log('dataline_1: '+dataline_1);
      countline_1='1';
    } else{
      countline_1='0';
    }
    console.log('countline_1: '+countline_1+", countline_2: "+countline_2+", countline_3: "+countline_3);
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '0'){
      final_data= dataline_1;
      final_break_hide= dataline_1;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_2;
      final_break_hide= dataline_2;
    }
    if(countline_1 == '0' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_3;
      final_break_hide= dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_1+"<br />"+dataline_2;
      final_break_hide= dataline_1+' --break-- '+dataline_2;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_3;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' || countline_2 == '1' || countline_3 == '1'){
      CountPOnBox = '1';
    }
    if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    total_word_count= parseInt(dataline_1.length)+parseInt(dataline_2.length)+parseInt(dataline_3.length);
    $('.characters').text( total_word_count +"/" + 36);
    if(total_word_count >= '9'){
      $(".bt-text-edit-box-inn-text").addClass("bt-text-edit-box-sml-text");
    }
    else{
      $(".bt-text-edit-box-inn-text").removeClass("bt-text-edit-box-sml-text");
    }
    if(total_word_count >= 6)
    {
      $(".bt-text-edit-box-inn-text").removeClass("cust-char-less-6");
    } else{
      $(".bt-text-edit-box-inn-text").addClass("cust-char-less-6");
    }
    $('p#printOnBox_livePreview').html(final_data);
    
    var finalValUpperCase= final_break_hide.toUpperCase();
    $(".cust_put_name22").val(finalValUpperCase);
    console.log($(".cust_put_name22").val());
  });
  $(document).on('input','.pobline_2', function(e){
    dataline_2= $(this).val();
    if(dataline_2 != ""){
      console.log('dataline_2: '+dataline_2);
      countline_2='1';
    } else{
      countline_2='0';
    }
    console.log('countline_1: '+countline_1+", countline_2: "+countline_2+", countline_3: "+countline_3);
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '0'){
      final_data= dataline_1;
      final_break_hide= dataline_1;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_2;
      final_break_hide= dataline_2;
    }
    if(countline_1 == '0' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_3;
      final_break_hide= dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_1+"<br />"+dataline_2;
      final_break_hide= dataline_1+' --break-- '+dataline_2;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_3;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' || countline_2 == '1' || countline_3 == '1'){
      CountPOnBox = '1';
    }
    if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    if(CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    total_word_count= parseInt(dataline_1.length)+parseInt(dataline_2.length)+parseInt(dataline_3.length);
    $('.characters').text( total_word_count +"/" + 36);
    if(total_word_count >= '9'){
      $(".bt-text-edit-box-inn-text").addClass("bt-text-edit-box-sml-text");
    }
    else{
      $(".bt-text-edit-box-inn-text").removeClass("bt-text-edit-box-sml-text");
    }
    if(total_word_count >= 6)
    {
      $(".bt-text-edit-box-inn-text").removeClass("cust-char-less-6");
    } else{
      $(".bt-text-edit-box-inn-text").addClass("cust-char-less-6");
    }
    $('p#printOnBox_livePreview').html(final_data);
    var finalValUpperCase= final_break_hide.toUpperCase();
    $(".cust_put_name22").val(finalValUpperCase);
    console.log($(".cust_put_name22").val());
  });
  $(document).on('input','.pobline_3', function(e){
    dataline_3= $(this).val();
    if(dataline_3 != ""){
      console.log('dataline_3: '+dataline_3);
      countline_3='1';
    } else{
      countline_3='0';
    }
    console.log('countline_1: '+countline_1+", countline_2: "+countline_2+", countline_3: "+countline_3);
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '0'){
      final_data= dataline_1;
      final_break_hide= dataline_1;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_2;
      final_break_hide= dataline_2;
    }
    if(countline_1 == '0' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_3;
      final_break_hide= dataline_3;
    }
    if(countline_1 == '1' && countline_2 == '1' && countline_3 == '0'){
      final_data= dataline_1+"<br />"+dataline_2;
      final_break_hide= dataline_1+' --break-- '+dataline_2;
    }
    if(countline_1 == '1' && countline_2 == '0' && countline_3 == '1'){
      final_data= dataline_1+"<br />"+dataline_3;
      final_break_hide= dataline_1+' --break-- '+dataline_3;
    }
    if(countline_1 == '0' && countline_2 == '1' && countline_3 == '1'){
      final_data= dataline_2+"<br />"+dataline_3;
      final_break_hide= dataline_2+' --break-- '+dataline_3;
    }
    if(countline_1 == '1' || countline_2 == '1' || countline_3 == '1'){
      CountPOnBox = '1';
    }
    if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
    total_word_count= parseInt(dataline_1.length)+parseInt(dataline_2.length)+parseInt(dataline_3.length);
    $('.characters').text( total_word_count +"/" + 36);
    if(total_word_count >= '9'){
      $(".bt-text-edit-box-inn-text").addClass("bt-text-edit-box-sml-text");
    }
    else{
      $(".bt-text-edit-box-inn-text").removeClass("bt-text-edit-box-sml-text");
    }
    if(total_word_count >= 6)
    {
      $(".bt-text-edit-box-inn-text").removeClass("cust-char-less-6");
    } else{
      $(".bt-text-edit-box-inn-text").addClass("cust-char-less-6");
    }
    $('p#printOnBox_livePreview').html(final_data);
    var finalValUpperCase= final_break_hide.toUpperCase();
    $(".cust_put_name22").val(finalValUpperCase);
    console.log($(".cust_put_name22").val());
  });
  /** End script three lines combined for textarea **/
  
  
    function newupdateCount2() {
      var custwords = $(this).val().length;
      $('.cust_counter2').text(custwords +"/" +15);
    }
    /* end put a name word counter */ 

     
  $(document).on('input','.cust_input', function(){

    var $this= $(this);

    
    var finalValUpper= $this.val().toUpperCase();
    //$this.val(finalValUpper);
    console.log("test val: "+$this.val());
    
    function resizeForm2(){
      var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
      if(width <= 1024) {

        var custwords = $this.val().length;
        var textPrintOnCase = $this.val();
        $('p#printOnCase_livePreview span').html(textPrintOnCase);  
        $('p#printOnCase_livePreviewMob span').html(textPrintOnCase);

        var POC_width= $('#printOnCase_livePreview').width();

        if(custwords <= '20'){

          if(POC_width <= '320' ){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
          } 
          if((POC_width >= '321') && (POC_width <= '380')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-1');
          }
          if((POC_width >= '381') && (POC_width <= '440')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-2');
          }
          if((POC_width >= '441') && (POC_width <= '500')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-3');
          }
          if((POC_width >= '501') && (POC_width <= '560')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-4');
          }
          if((POC_width >= '561') && (POC_width <= '620')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-5');
          }
          if((POC_width >= '621') && (POC_width <= '680')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-6');
          } 
          if((POC_width >= '681') && (POC_width <= '740')){
            $('#printOnCase_livePreviewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewMob').addClass('fixfont-6');
          } 
        }


        $('.cust_counter').text(custwords +"/" +20);
        if(custwords > '0'){
          console.log('added print on case');
          CountPOnCase = '1';
        } else{
          CountPOnCase = '0';
        }
        if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
          $('.shopify-payment-button__button').prop('disabled', false);
          $('.Cust_Product_Buttons_inner button').prop('disabled', false);
        } else{
          $('.shopify-payment-button__button').prop('disabled', false);
          $('.Cust_Product_Buttons_inner button').prop('disabled', false);
        }
        if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    }
        /* add/remove  class in div when chracter count 14*/
        if(custwords > '14'){
          $(".bt-text-edit-case-inn-text").addClass("cust-case-text-content");
        }
        else{
          $(".bt-text-edit-case-inn-text").removeClass("cust-case-text-content");
        }
        /* end add/remove class in div when chracter count 14*/


      } // if mob
    }
    window.onresize = resizeForm2;
    resizeForm2();


  });
    $(document).on('input','.cust_input3', function(){

    var $this= $(this);

    
    var finalValUpper= $this.val().toUpperCase();
    $this.val(finalValUpper);
    console.log("test val: "+$this.val());
    
    function resizeForm2(){
      var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
      if(width <= 1024) {

        var custwords3 = $this.val().length;
        var textPrintOnCase = $this.val();
        $('p#printOnCase_livePreviewDesk span').html(textPrintOnCase);  
        $('p#printOnCase_livePreviewnewMob span').html(textPrintOnCase);

        var POC_width3= $('#printOnCase_livePreviewDesk').width();

        if(custwords3 <= '15'){

          if(POC_width3 <= '320' ){
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-6');
          } 
          if((POC_width3 >= '321') && (POC_width3 <= '380')){
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewnewMob').addClass('fixfont-1');
          }
          if((POC_width3 >= '381') && (POC_width3 <= '440')){
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewnewMob').addClass('fixfont-2');
          }
          if((POC_width3 >= '441') && (POC_width3 <= '500')){
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-1');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-2');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-3');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-4');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-5');
            $('#printOnCase_livePreviewnewMob').removeClass('fixfont-6');
            $('#printOnCase_livePreviewnewMob').addClass('fixfont-3');
          }
        }


        $('.new_cust_counter').text(custwords3 +"/" +15);
        if(custwords3 > '0'){
          console.log('added print on case');
          CountPOnCase = '1';
        } else{
          CountPOnCase = '0';
        }
        if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
          $('.shopify-payment-button__button').prop('disabled', false);
          $('.Cust_Product_Buttons_inner button').prop('disabled', false);
        } else{
          $('.shopify-payment-button__button').prop('disabled', true);
          $('.Cust_Product_Buttons_inner button').prop('disabled', true);
        }
        if( CountPOnCase == '1' && CountPOnBox == '1'){
      $('.shopify-payment-button__button').prop('disabled', false);
      $('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
      $('.shopify-payment-button__button').prop('disabled', true);
      $('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
        /* add/remove  class in div when chracter count 14*/
        if(custwords3 > '14'){
          $(".bt-text-edit-case-inn-text").addClass("cust-case-text-content");
        }
        else{
          $(".bt-text-edit-case-inn-text").removeClass("cust-case-text-content");
        }
        /* end add/remove class in div when chracter count 14*/


      } // if mob
    }
    window.onresize = resizeForm2;
    resizeForm2();


  });  

  	$(document).on('touchstart','.cust_input2', function(newupdateCount12){
      function newupdateCount12(){
        var custwords = newupdateCount12.touches.length;
        $('.cust_counter2').text(custwords +"/" +15);
      } 
    });
 	$('.variantoptions').on('change', function() {  
        var collVariant = $(this).val();
        console.log(collVariant);  

        $(".Popover__ValueList").children(".Popover__Value").each(function(){

          var optionVal =  $(this).attr("data-value");
          console.log("optionVal "+ optionVal);

          if(collVariant == optionVal ){
            console.log("matched"); 
            CoountDrop= "1";
            $(this).trigger("click");
          }
        });
      
      	//console.log("CoountDrop: "+CoountDrop+", CountPOnCase: "+CountPOnCase+", CountPOnBox: "+CountPOnBox);
      	if(CoountDrop == '1' && CountPOnCase == '1' && CountPOnBox == '1'){
          $('.shopify-payment-button__button').prop('disabled', false);
          //$('.Cust_Product_Buttons_inner button').prop('disabled', false);
        } else{
          $('.shopify-payment-button__button').prop('disabled', true);
         // $('.Cust_Product_Buttons_inner button').prop('disabled', true);
        }
        if( CountPOnCase == '1' && CountPOnBox == '1'){
      //$('.shopify-payment-button__button').prop('disabled', false);
      //$('.Cust_Product_Buttons_inner button').prop('disabled', false);
    } else{
     // $('.shopify-payment-button__button').prop('disabled', true);
      //$('.Cust_Product_Buttons_inner button').prop('disabled', true);
    }
      
      });
    /*end product page choose option */
 }
  
  /* show tooltip when click on tooltip */
    $(".line-item-property__field").children(".put_a_neme").siblings(".cst-clk-info-icon").click(function(){
      console.log('clicked siblling test');
      $(this).toggleClass('cst-clk-info-open-tt');
    }); 
  
  
  
    $(".cust-main-attr3").find(".cst-clk-info-icon").click(function(){
      console.log('clicked siblling test');
      $(this).toggleClass('cst-clk-info-open-tt');
    });
  
  
  
	$(document).on('click', function(event) {
      if (!$(event.target).closest('.cst-clk-info-icon').length)  {
        $(".cst-clk-info-icon").removeClass("cst-clk-info-open-tt");
      }
    });
 
    $(".cust_select_option").click(function(){
     $(this).toggleClass('cst-clk-info-open-tt');
    });
 

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.cust_select_option').length)  {
      console.log("click");
      $(".cust_select_option").removeClass("cst-clk-info-open-tt");
    }
  });

  /* end show tooltip when click on tooltip */
  
  /*timeline section arrows */ 
  $(".cust_right").click(function(){
    $(this).parent(".cust_timeline_arrows").prev(".Timeline__Nav").children(".Timeline__NavWrapper").children(".Timeline__NavItem").each(function( ){ 
    
  // $(".Timeline__NavItem").each(function( ){ 
      var GetIndex = $(this).attr("data-index");
    //  console.log("GetIndex " + GetIndex);
      
     var currentSlide = $(this).parent(".Timeline__NavWrapper ").parent(".Timeline__Nav").prev(".Timeline__ListItem").children(".Timeline__Item.is-selected").attr("data-index"); 
      console.log("currentSlide "+ currentSlide);
      var nextSlide = parseInt(currentSlide)+ 1;
      //console.log("nextSlide "+ nextSlide);
      if(GetIndex  == nextSlide){
       //console.log("matched " + GetIndex);
        $(this).trigger("click");
      }
    });
  });

    
  $(".cust_left").click(function(){
    $(this).parent(".cust_timeline_arrows").prev(".Timeline__Nav").children(".Timeline__NavWrapper").children(".Timeline__NavItem").each(function( ){ 
    
  // $(".Timeline__NavItem").each(function( ){ 
      var GetIndex = $(this).attr("data-index");
    //  console.log("GetIndex " + GetIndex);
      
     var currentSlide = $(this).parent(".Timeline__NavWrapper ").parent(".Timeline__Nav").prev(".Timeline__ListItem").children(".Timeline__Item.is-selected").attr("data-index"); 
      console.log("currentSlide "+ currentSlide);
      var nextSlide = parseInt(currentSlide)-1;
      //console.log("nextSlide "+ nextSlide);
      if(GetIndex  == nextSlide){
       //console.log("matched " + GetIndex);
        $(this).trigger("click");
      }
    });
  });

 /*End timeline section arrows */   
 
  /* product page slider */
$('.cust_main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.cust_thumb'
});
$('.cust_thumb').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.cust_main',
  dots: false,
  vertical:true,
  centerMode: false,
  focusOnSelect: false,
  arrows: true,
  prevArrow: '<div class="custm_slick-up text-center"><i aria-hidden="true" class="fa fa-angle-up"></i></div>',
  nextArrow: '<div class="custm_slick-down text-center"><i aria-hidden="true" class="fa fa-angle-down"></i></i></div>',
});
/* end product page slider */ 
 
  $('.ProductThumbsSlideInner').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: '40px',
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          loop:true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  if ($("body").hasClass("CustomLipstickPrd")) {
    console.log("custom lipstick product"); 

    // Start hover effect for desktop view main nav
    function resizeForm(){
      var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
      if(width > 1007) {
        console.log('desk devices');
		var NewHeight= $('.Product__Aside').attr('style').split('min-height: ')[1];
        var newStyle= 'height: '+NewHeight;
        console.log(" NewHeight: "+NewHeight+" newStyle: "+newStyle);
        $('.Product__Aside .Product__Tabs').attr('style',newStyle);
      } // if desktop above 1007
      else{
		console.log('mob devices');
        var GetHeightAside= $('.Product__Aside').outerHeight();
        var newStyleEmptyTabs= 'height: '+GetHeightAside+'px';
        $('.Product__Aside').attr('style',newStyleEmptyTabs);
        
      } // if devices upto 1007
    }
    window.onresize = resizeForm;
    resizeForm();
    // End hover effect for desktop view main nav
        
  } // if customize product page
  
 // if cart page
 
  
  // start if radio change product page 
  $(document).on('change','.box_sel_prd', function() {
    console.log('change select box radio');
    $('.bt-lip-packaging-box').removeClass('active_box_sel');
    $(this).parent().parent().parent().addClass('active_box_sel');
  }); 
  // end if radio change product page

  /* Change preview image when select any value from choose box*/
  $(".box_sel_prd").click(function(){
    console.log("test check");
    var getImaGe = $(this).parent(".bt-lip-packaging-check").parent(".bt-lip-packaging-title").prev(".bt-lip-packaging-img").children(".image-popup-vertical-fit").attr("href");
    console.log("getImaGe " + getImaGe);

    var GetPrivewImg = $(".bt-text-edit-box-container").children("img").attr("src",getImaGe);
    console.log("GetPrivewImg " + GetPrivewImg);
  });

  /* end Change preview image when select any value from choose box*/
  
  if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    
    $(function () {
      $(".pob_lines_inbox").keypress(function (e) {
        var this_val= $(this).val().length;
        console.log("count chars: "+this_val);
        var mkey  = e.which || e.keyCode || e.charCode;
        $("#lblError").html("");      
        var regex2 = new RegExp("^[a-zA-Z0-9 '.-_!@:#<>*&~]");
        var str2 = String.fromCharCode(e.charCode ? e.which :e.keyCode );
        if (regex2.test(str2)) {
        }
        else{
         $("#lblError").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
         return false;
        } 
      });
    });
    
    $(function () {
      $(".PutNamePrd").keypress(function (e) {
        var keyCode = e.keyCode || e.which;
        $("#lblError1").html("");
        $("#lbllipglosserror").html("");
        var regex1 = new RegExp("[a-zA-Z0-9 '.-_!@:#<>*&~]");
        var str1 = String.fromCharCode(e.charCode ? e.which : e.charCode);

       if (regex1.test(str1)) {

        }
        else{
         $("#lblError1").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
          $("#lbllipglosserror").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
          return false;
        }
      });
    });
    
    
  } else{
    
    
    $(document).on('input','.pob_lines_inbox', function(e){
    var current_value = $(this).val();
    var reg_exp= /[^a-zA-Z0-9 '.-_!@:#<>*&~]+$/;
    if(reg_exp.test(current_value)){
      var new_val = current_value.replace(/[^a-zA-Z0-9 '.-_!@:#<>*&~]/g, "");
      $(this).val(new_val);
      $("#lblError").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
    } else{
      $("#lblError").html("");
    }
  }); 
  
  
  
  
  $(document).on('input','.PutNamePrd', function(e){
    var current_value = $(this).val();
    var reg_exp= /[^a-zA-Z0-9 '.-_!@:#<>*&~]+$/;
    if(reg_exp.test(current_value)){
      var new_val = current_value.replace(/[^a-zA-Z0-9 '.-_!@:#<>*&~]/g, "");
      $(this).val(new_val);
      $("#lblError1").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
       $("#lbllipglosserror").html("Only letters A-Z, numbers 0-9 and symbols '._!@:#<>*&~/\[] allowed.");
    } else{
      $("#lblError1").html("");
       $("#lbllipglosserror").html("");
    }
  }); 
    
  }
  
 
  
  /* add class in live preview for Print On The Box*/

  /* end add class in live preview for Print On The Box*/  
  $(".bt-text-edit-box-inn-text").addClass("cust-char-less-6");
}); // end document ready

$('.image-popup-vertical-fit').magnificPopup({
  type: 'image',
  closeOnContentClick: true,
  mainClass: 'mfp-img-mobile',
  image: {
  verticalFit: true
  }
});


(function(){
  var r = document.querySelector('.shopify-policy__body');
  if (r) {
    r.firstElementChild.classList.add('Rte'); 
  }
}());
  
/* live preview popup on mobile */
$( window ).load(function() {
  // Run code
  var newhtml= '<div class="custm_fit_size custSizenew"><a id="inline" href="#pop-up">Show live preview</a></div>';
  $('body.template-product').after(newhtml);
  //fancybox
  $("a#inline").fancybox(); 
  
  
 var newhtmltest= '<div class="custm_fit_size custSizenew"><a id="inlinenew" href="#pop-up2">Show live preview</a></div>';
 $('body.template-product').after(newhtmltest);
	$("a#inlinenew").fancybox();

});
/* live preview popup on mobile */

$(document).ready(function() {
 
	$(".searchbar").click(function(e) {
      e.preventDefault();
	   $(".togglesearch_1").fadeIn();
       $(".togglesearch_2").fadeIn();
	   $(".Search__Input").focus();
       $(".Search__Input").val('');
        $('body').addClass('previent-scrolling');
	 });


  $(".togglesearch_1").on('click',function(){
    $(".togglesearch_1").fadeOut();
     $(".togglesearch_2").fadeOut();
    $('body').removeClass('previent-scrolling');
    $(".Search__Input").val('');
  })

  $(".custvar_2").on('change',function(){
    var $this = $(this);
    if($this.val() == "Yes"){
      $("#image_expand_box").fadeIn();
    }else{
      $("#image_expand_box").fadeOut();
    }
  })

});

$(".show").on("click", function(){
  $(".mask").addClass("active");
});

// Function for close the Modal

function closeModal(){
  $(".mask").removeClass("active");
}

// Call the closeModal function on the clicks/keyboard

$(".close, .mask").on("click", function(){
  closeModal();
});

$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    closeModal();
  }
});


 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.slider-for',
  dots: false,
  vertical: true,
  verticalSwiping: true,
  centerMode: false,
  swipeToSlide: true,
   focusOnSelect: true
});

var sub_width = 0;
      var sub_height = 0;
      $(".large").css("background","url('" + $(".small").attr("src") + "') no-repeat");
$(".zoom-area").mousemove(function(e){
        if(!sub_width && !sub_height)
        {
          var image_object = new Image();
          image_object.src = $(".small").attr("src");
          sub_width = image_object.width;
          sub_height = image_object.height;
        }
        else
        {
          var magnify_position = $(this).offset();

          var mx = e.pageX - magnify_position.left;
          var my = e.pageY - magnify_position.top;
          
          if(mx < $(this).width() && my < $(this).height() && mx > 0 && my > 0)
          {
            $(".large").fadeIn(100);
          }
          else
          {
            $(".large").fadeOut(100);
          }
          if($(".large").is(":visible"))
          {
            var rx = Math.round(mx/$(".small").width()*sub_width - $(".large").width()/2)*-1;
            var ry = Math.round(my/$(".small").height()*sub_height - $(".large").height()/2)*-1;

            var bgp = rx + "px " + ry + "px";
            
            var px = mx - $(".large").width()/2;
            var py = my - $(".large").height()/2;

            $(".large").css({left: px, top: py, backgroundPosition: bgp});
          }
        }
      });
//product-img--main zoom
   
        //


var capture_product = location.search.split('product=')[1];
  if(typeof capture_product !== 'undefined' &&  capture_product!=""){     
     $(".item_handle_"+capture_product).addClass('highlight_product')
  }

// loader js start add to cart btn private label page
$(document).ready(function () {
    
    // $('.has-spinner').click(function () {
    //     var btn = $(this);
    //     $(btn).buttonLoader('start');
    //     setTimeout(function () {
    //         $(btn).buttonLoader('stop');
    //     }, 3000);
    // });
});
// (function ($) {
//     $.fn.buttonLoader = function (action) {
//         var self = $(this);
//         //start loading animation
//         if (action == 'start') {
//             if ($(self).attr("disabled") == "disabled") {
//                 e.preventDefault();
//             }
//             //disable buttons when loading state
//             $('.has-spinner').attr("disabled", "disabled");
//             $(self).attr('data-btn-text', $(self).text());
//             //binding spinner element to button and changing button text
//             $(self).html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span>Add to Cart');
//             $(self).addClass('active');
//         }
//         //stop loading animation
//         if (action == 'stop') {
//             $(self).html($(self).attr('data-btn-text'));
//             $(self).removeClass('active');
//             //enable buttons after finish loading
//             $('.has-spinner').removeAttr("disabled");
//         }
//     }
// })(jQuery);

// loader js end add to cart btn private label page
//sticky add to cart btn start

    $(window).scroll(function() {
      if ($(window).scrollTop() >= 500) {
        $('.template-product.PrivateTemplateproduct .on_scroll_addbtn').addClass('btn_sticky');
      } else {
        $('.template-product.PrivateTemplateproduct .on_scroll_addbtn ').removeClass('btn_sticky');

      }

  });
$('.expand_level_1').on('click',function(){
  var  $this = $(this);
  
   $this.parent().toggleClass('show');
   $this.parent().find('.submenu_container_nw').toggleClass('open');
   $this.toggleClass('show');
})
$('.has-child-menu ').on('click',function(){
  var  $this = $(this);
   $this.parent().toggleClass('show');
   $this.parent().find('.submenu_container_nw').toggleClass('open');
   $this.parent().find('.expand_level_1').toggleClass('show');
})

$('.expand_level_2').on('click',function(){
  var  $this = $(this);
   $this.parent().find('.submenu_container_nw_level3').toggleClass('show');
   $this.parent().find('.submenu_container_nw_level3').toggleClass('open');
   $this.toggleClass('show');
})

$('.threelevel_menu').on('click',function(){
  var  $this = $(this);
  //$this.next().toggleClass('show');
    //$this.parent().find('.submenu_container_nw_level3').toggleClass('show');
   $this.parent().find('.submenu_container_nw_level3').toggleClass('show');
   $this.parent().find('.submenu_container_nw_level3').toggleClass('open');
   
  $this.parent().find('.expand_level_2').toggleClass('show');
})


if ($("body").hasClass("template-cart")) {
    setTimeout(function(){ 
      $(".CustomizeLipPrd").each(function( index ) {
        var This= $(this);
        var GetColor= This.find('.ColorSelVal').text();
        var splitCode= GetColor.split("color mix: ");
        console.log("GetColorCode: "+GetColor+"splitCode: "+splitCode[1]);
        This.find('.CartItem__Image').css('background-color',splitCode[1]);
      });

      $(".CustomizeLipPrdCase").each(function( index ) {
        var This= $(this);
        var GetColor= This.find('.ColorSelVal').text();
        var splitCode= GetColor.split("color mix: ");
        //console.log("GetColorCode: "+GetColor+"splitCode: "+splitCode[1]);
        This.find('.CartItem__Image').css('background-color',splitCode[1]);
      });

      $(".CustomizeLipPrdCase").each(function( index ) {
        var This= $(this);
        var GetColor= This.find('.ColorSelValHeart').text();
        var splitCode= GetColor.split("color heart mix: ");
        This.find('.caseCartHeart').css('fill',splitCode[1]);
      });
    }, 3000);
    
    $(document).on('click','.QuantitySelector__Button', function(){
      console.log('clicked quantity button');
    });
    
  } 

function get_after(string){
  if (typeof string !== "undefined") {
    return string.substr(string.indexOf(' / ')+3,)
  }
  
}
function get_before(string){
  if (typeof string !== "undefined") {
    return string.substr(0, string.indexOf('/')); 
  }
}
setTimeout(set_variant_titles, 3000);
function set_variant_titles(){
  $.each($(".CartListCbd"),function(){
    var cust_set_1 = $(this).find(".cust_set_1");
    var cust_set_2 = $(this).find(".cust_set_2");
    //console.log("FIND "+cust_set_1.attr('data-title'))
    //console.log("FIND "+cust_set_2.attr('data-title'))
     cust_set_1.text(cust_set_1.attr('data-title')+": "+get_before(cust_set_1.attr('data-string')));
     cust_set_2.text(cust_set_2.attr('data-title')+": "+get_after(cust_set_2.attr('data-string')));
  });


  $(".pdp_case_font").change(function(){
      $("#printOnCase_livePreview").css({'font-family':$(this).val()});
      $("#printOnCase_livePreviewMob").css({'font-family':$(this).val()});
      $("#pdp_case_font").val($(".pdp_case_font :selected").text());
  });
  $("#pdp_case_font").val($(".pdp_case_font :selected").text());
  
}